function getCurrentLocationUrl(): string {
  const {pathname, search} = new URL(window.location.href);

  return pathname + search;
}

export default getCurrentLocationUrl;
